import PropTypes from 'prop-types';

export const exportExcel = (dataExport) => ({
    dataExport: dataExport,
    filename: 'spiideo_competitor_mappings',
    parseData: (row) => [
        row.competitor?.sport?.name ?? '',
        row.competitor?.tournament_category?.name ?? '',
        row.competitor ? `${row.competitor.name} (${row.competitor.id})` : '',
        row.spiideo_team_uuid ?? '',
        row.sportradar_srt_url ?? '',
        row.ligr_srt_url ?? '',
    ],
    path: 'spiideoMappings.competitors.path',
    titles: [
        'Sport',
        'Category',
        'Competitor',
        'Spiideo team UUID',
        'Sportradar SRT URL',
        'LIGR SRT URL',
    ],
});

exportExcel.propTypes = {
    dataExport: PropTypes.array.isRequired,
};
